export const environment = {
  production: true,

  logo_icon: 'assets/images/Logo.png',
  // -- Map Config
  map_initial_center: { lat: 28.258686, lng: -81.621495 },

  map_initial_zoom: 8,
  map_max_zoom: 40,
  map_type: 'roadmap',

  deployment: 'DIVAS',
  snapshotsUrl_core: 'dis.divas.cloud',

  eventsRefreshTimer: 60,

  // -- Notification Config
  notifications_error_display_intervals_in_seconds: 5,
  notifications_success_display_interval_in_seconds: 3,
  notifications_info_display_interval_in_seconds: 3,
  notificatios_warn_display_interval_in_seconds: 5,

  // -- Snapshot Config
  refresh_image_interval: 15000,

  // -- Mobile Camera refresh timer in ms
  mobileCameraRefreshTimer: 5000,


  // -- Video Config
  total_wall_cameras: 6,
  new_wall_cameras: 30,

  // -- Release Info
  version: '2.5.4.0',
  release_date: 'March 23, 2026',

  token_timeSpan_days: 14,

  eventsTabVisible: true,
  eventsMapVisible: true,

  show_access_to_dfs_option: true,
  showCreateNewAccountRequest: false,
  showReportAnIssueButton: false,
  sarsRequired: false,

  pixelBreakpointSmallScreen: 1025,
  
  

  external_walls_tab: true,

  walls_tab_visible: true,
  walls_tours_tab_visible: true,

  cameras_tours_tab_visible: false,

  is2FA: false,
  isSsoAzureAD: false,
  sendEmailOnUserCreation: true,

  refreshNativeAppsTimerInterval: 5,
  loginStatusRefreshTimer: 30,

  vds_UI_url: 'https://divas.cloud/divas-vas', // prod
  // vds_UI_url: 'https://dfsqa.divas.cloud/divas-vas', // staging

  // -- APIs Config
  // -- DIVAS PROD Env
  api_url: '/divas-vas/api/', // https://divas.cloud/divas-vas/api/

  hubConnectionUrl: 'http://172.30.63.21:5071/signalr',

  /* TODO:
    Remember to change both manifest.json (one in src/ and one in te root directory) to point to correct website.

    DIVAS -- main (the one that has both DFS-VDS):
    "scope": "https://divas.cloud/divas-vas/",
    "start_url": "https://divas.cloud/divas-vas/",

    "scope": "https://dis.divas.cloud/divas-vas/",
    "start_url": "https://dis.divas.cloud/divas-vas/",

    // staging
    "scope": "https://dfsqa.cloud/divas-vas/",
    "start_url": "https://dfsqa.cloud/divas-vas/",

    // D4 prod
    "scope": "https://ivds.smartsunguide.com/",
    "start_url": "https://ivds.smartsunguide.com/",

    // D5 prod
    "scope": "https://ivds.cflsmartroads.com/",
    "start_url": "https://ivds.cflsmartroads.com/",

    // D1 prod
    "scope": "https://d1.divas.cloud/",
    "start_url": "https://d1.divas.cloud/",

    // MTO prod
    "scope": "https://ivds.compass-cctv.com/app/",
    "start_url": "https://ivds.compass-cctv.com/app/",

    // D3 prod
    "scope": "https://d3.divas.cloud/",
    "start_url": "https://d3.divas.cloud/",

    // PennDOT      
      "scope": "https://pa.arcadis-ivds.com/app",
      "start_url": "https://pa.arcadis-ivds.com/app",

      // NCDOT      
      "scope": "https://nc.arcadis-ivds.com/app",
      "start_url": "https://nc.arcadis-ivds.com/app",

    //////////////
    the rest:
    "scope": "/",
    "start_url": "/",
  */
};
